/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantRelationshipDto } from './TenantRelationshipDto';
import {
    TenantRelationshipDtoFromJSON,
    TenantRelationshipDtoFromJSONTyped,
    TenantRelationshipDtoToJSON,
    TenantRelationshipDtoToJSONTyped,
} from './TenantRelationshipDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Response containing a tenant relationship
 * @export
 * @interface TenantRelationshipResponse
 */
export interface TenantRelationshipResponse {
    /**
     * Tenant relationship data
     * @type {TenantRelationshipDto}
     * @memberof TenantRelationshipResponse
     */
    relationship?: TenantRelationshipDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRelationshipResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof TenantRelationshipResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof TenantRelationshipResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof TenantRelationshipResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the TenantRelationshipResponse interface.
 */
export function instanceOfTenantRelationshipResponse(value: object): value is TenantRelationshipResponse {
    return true;
}

export function TenantRelationshipResponseFromJSON(json: any): TenantRelationshipResponse {
    return TenantRelationshipResponseFromJSONTyped(json, false);
}

export function TenantRelationshipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantRelationshipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'relationship': json['relationship'] == null ? undefined : TenantRelationshipDtoFromJSON(json['relationship']),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function TenantRelationshipResponseToJSON(json: any): TenantRelationshipResponse {
    return TenantRelationshipResponseToJSONTyped(json, false);
}

export function TenantRelationshipResponseToJSONTyped(value?: TenantRelationshipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationship': TenantRelationshipDtoToJSON(value['relationship']),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

